import Vue from "vue";
import Vuetify from "vuetify/lib";

import fr from "./../i18n/fr";
import en from "./../i18n/en";

import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  lang: {
    locales: { fr, en },
    current: "fr"
  },
  theme: {
    themes: {
      light: {
        primary: "#4B22E9",
        secondary: "#311B92",
        error: "#B71C1C",
        success: "#00BFA5",
        warning: "#FF6F00",
        third: "#FF6F00"
      }
    }
  }
});
